export const IMAGE_PDF = 'IMAGE_PDF';
export const SCAN_OCR = 'SCAN_OCR';
export const TRUE_PDF = 'TRUE_PDF';
export const IMAGE = 'IMAGE';
export const MIXED_PAGE_PDF = 'MIXED_PAGE_PDF';
export const EMPTY = 'EMPTY_PDF';
export const FLATTENED_PDF = 'FLATTENED_PDF';
